import ProductDetailsBrochure from './ProductDetailsBrochure';

export default function ProductDetailsSection({ productData, imagePressed }) {
    return (
        <div className='product-details-section'>

            <div style={{ marginTop: 15 }}>
                {
                    productData.tblProductImages != null ?
                        <ProductDetailsBrochure
                            imagePressed={(item) => { imagePressed(item) }}
                            data={productData.tblProductImages == null ? [] : productData.tblProductImages}
                            stock={productData.isStockAvailable}
                        />
                        :
                        <div style={{ justifyContent: 'center', alignItems: 'center', flex: 1, height: 120, display: 'flex' }}>
                            <p>No Preview</p>
                        </div>
                }
            </div>
        </div>
    )


}